import { Card, Col, Row, Table as AntTable } from "antd";

import { styles } from "@evolved/constants";
import { AddButton } from "components/add-button";
import { MigrationModal } from "./migration-modal";
import { useModal } from "hooks/use-modal";
import { useOrganization } from "data/use-organization";
import { useSalesProcesses } from "data/use-sales-processes";
import { withManagerRole } from "components/with-role";

const CreateMigrationButton = withManagerRole(({ open }) => {
  return (
    <>
      <AddButton
        id="create-sales-process-migration-button"
        onClick={() => open()}
        style={{ marginLeft: "auto" }}
      >
        Migration
      </AddButton>
    </>
  );
});

export const SalesProcessMigrations = withManagerRole(() => {
  const organization = useOrganization();

  const migrations =
    organization.settings?.opportunitySalesProcessMigrations ?? [];
  const salesProcesses = useSalesProcesses();

  const { modal, open } = useModal(MigrationModal);

  const columns = [
    {
      title: "From",
      dataIndex: "fromId",
      key: "fromId",
      render: (id) => {
        return salesProcesses.byId(id).name;
      },
    },
    {
      title: "To",
      dataIndex: "toId",
      key: "toId",
      render: (id) => {
        return salesProcesses.byId(id).name;
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (row) => {
        return (
          <div>
            <div
              key="update-migration"
              style={styles.CLICKABLE_STYLE}
              onClick={() => open({ migration: row })}
            >
              edit
            </div>
            ,
          </div>
        );
      },
    },
  ];

  return (
    <Row justify={"center"} type={"flex"} style={{ marginTop: "24px" }}>
      {modal}
      <Col xs={24} xl={12}>
        <div className="mb-2 flex">
          <h4>Migrations</h4>
          <div className="ml-auto flex flex-col items-end">
            <CreateMigrationButton open={open} />
          </div>
        </div>
        <Card bodyStyle={{ padding: 0 }} bordered={false}>
          <AntTable
            columns={columns}
            dataSource={migrations}
            locale={{
              emptyText: "You have no migrations defined.",
            }}
            id="sales-process-migrations"
            rowKey="_id"
            size="middle"
          />
        </Card>
      </Col>
    </Row>
  );
});
